module.exports = __webpack_public_path__ + "img/vue1-arriere_vert.3aae3d62.png";